import React from "react";
import FooterLandingSmall from "src/components/footer/FooterLandingSmall";
import { LandingHead } from "@heads/HealthWeight";
import { usePageView } from "src/hooks/tracking";
import ClinicalIntro from "src/components/intro/ClinicalIntro";
import { isFreemiumClinicalRoute } from "@utils/userSegment";
import { useOnce } from "src/hooks/lifecycle";
import { trackMmpEvent } from "@utils/api/tracker";

export default function LandingPage() {
  usePageView("landing");
  useOnce(() => {
    if (isFreemiumClinicalRoute()) {
      trackMmpEvent("mmpBuyflowPageViewed", {
        pageId: "freemiumClinicalLanding",
      });
    }
  });
  return (
    <>
      <LandingHead />
      <ClinicalIntro />
      <FooterLandingSmall />
    </>
  );
}
